import GlobalErrorHandler from "./GlobalErrorHandler";

export { errorToastCallback } from "./apolloErrorLink";
export default GlobalErrorHandler;
